import { render } from "./TicketColorsDialog.vue?vue&type=template&id=1c61b822"
import script from "./js/ticketColorsDialog.js?vue&type=script&lang=js&external"
export * from "./js/ticketColorsDialog.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__